module.exports = __webpack_public_path__ + "static/media/ic_italic.9b85495f.svg";